import { withErrorBoundary } from "@/components/hoc";
import { LoginForm } from "@/components/auth";

const Login: React.FC = () => {
    return <LoginForm />;
};

export default withErrorBoundary({ component: "Login" })(Login);
